module.exports = __webpack_public_path__ + "img/upgrader.172ff45f.png";